import { Icon } from "@iconify/react";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addError, getCallId, getUserData } from "../../Redux/UserSlice";
import { backendApi, callPlayBot, LiveCallApi } from "../../services/service";
import LoaderComp from "../../LoaderComp";
const PolicyDetails = ({ setPage, languageContent, userData }) => {
  //eng 25sec
  //
  const user = useSelector(getUserData);
  const call_id = useSelector(getCallId);
  const dispatch = useDispatch();
  const [showButtons, setShowButtons] = useState(false);
  const [liveCallResponse, setLiveCallResponse] = useState(false)


  let nudge30SecondTimer = useRef(null)
  let nudge60SecondTimer = useRef(null)

  const template_policy_detail = async () => {
    await callPlayBot(call_id, "policy_detail")
      .then((res) => {
        if (res.data === 200) {
          console.log("okay play api");
        }
      })
      .catch((e) => console.log(e.message));
  };
  const template_nudge = () => {
    callPlayBot(call_id, "no_input_nudge")
      .then((res) => console.log(res.data))
      .catch((e) => console.log(e.message));
  }
  const submitApi = async (key, value) => {
    await backendApi(call_id, key, value)
      .then((res) => {
        if (res.data) {
          // setPage("verification");
          console.log(res.data);
        }
      })
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
    await LiveCallApi(call_id)
      .then((res) => {
        console.log(res.data);
        if (res.data === false) {
          setShowButtons(true);
          if(userData.flow_type && userData.flow_type.toLowerCase() === "hdfc"){
            setPage('callDisconnected')
            
          }
        }
        setLiveCallResponse(true)
      })
      .catch((e) => {
        setPage("sorryPage");
      });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    submitApi("policyDetail", "open");
    template_policy_detail();
    nudge30SecondTimer = setTimeout(() => template_nudge(), 56000);
    nudge60SecondTimer = setTimeout(() => template_nudge(), 86000);

    const id = setTimeout(() => {
      setShowButtons(true);
    }, 26000);
    return () => {
      clearTimeout(id)
      clearNudgeTimers();
    };
  }, []);

  const clearNudgeTimers = () => {
      clearTimeout(nudge30SecondTimer)
      clearTimeout(nudge60SecondTimer)
  }

  const handleAgreePolicyDetails = async () => {
    clearNudgeTimers()
    await backendApi(call_id, "policy_page", "agree")
      .then((res) => {
        if (res.data) {
          setPage("information");
        }
      })
      .catch((e) => {
        dispatch(e.message);
        setPage("sorryPage");
      });
  };
  const handleDisagreePolicyDetails = async () => {
    clearNudgeTimers()
    await backendApi(call_id, "policy_page", "disagree")
      .then((res) => {
        if (res.data) {
          setPage("policyDetailsDisagree");
        }
      })
      .catch((e) => {
        dispatch(e.message);
        setPage("sorryPage");
      });
  };
  return (
    liveCallResponse ? <>
      <div className="heading">
        <p>{languageContent.policy_detail_page.policy_title}</p>
      </div>
      <hr></hr>
      <table className="table">
        <tbody>
          <tr>
            <td>
              <Icon
                icon="bx:bxs-briefcase"
                inline={true}
                color="#505050"
                style={{ marginRight: "0.25rem" }}
              />
              <span className="table-col-heading">
                {languageContent.policy_detail_page.plan_name}
              </span>
              <br />
              <span className="table-col-data">{user.plan_name}</span>
            </td>
            <td>
              <Icon
                icon="clarity:alarm-clock-solid-alerted"
                inline={true}
                color="#505050"
                style={{ marginRight: "0.25rem" }}
              />
              <span className="table-col-heading">
                {languageContent.policy_detail_page.payment}
              </span>
              <br />
              <span className="table-col-data">{user.payment_frequency}</span>
            </td>
          </tr>
          <tr>
            <td>
              <Icon
                icon="clarity:date-solid"
                inline={true}
                color="#505050"
                style={{ marginRight: "0.25rem" }}
              />
              <span className="table-col-heading">
                {languageContent.policy_detail_page.policy_term}
              </span>
              <br />
              <span className="table-col-data">
                {user.policy_term}
                {languageContent.policy_detail_page.years}
              </span>
            </td>
            <td>
              <Icon
                icon="clarity:date-solid-alerted"
                inline={true}
                color="#505050"
                style={{ marginRight: "0.25rem" }}
              />
              <span className="table-col-heading">
                {languageContent.policy_detail_page.premium_payment}
              </span>
              <br />
              <span className="table-col-data">
                {user.payment_term}
                {languageContent.policy_detail_page.years}
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <img
                src="./rupee.png"
                alt="Rupee"
                height="20px"
                width="20px"
                style={{ marginRight: "4px" }}
              />
              <span className="table-col-heading">
                {languageContent.policy_detail_page.premium_amount}
              </span>
              <br />
              <span className="table-col-data">INR {user.premium_amount}</span>
            </td>
            <td>
              <img
                src="./money-bag.png"
                alt="Bag"
                height="20px"
                width="20px"
                style={{ marginRight: "4px" }}
              />
              <span className="table-col-heading">
                {languageContent.policy_detail_page.sum_assured}
              </span>
              <br />
              <span className="table-col-data">INR {user.sum_assured}</span>
            </td>
          </tr>
          <tr>
            <td>
              <img
                src="./welfare.png"
                alt="Welfare"
                height="20px"
                width="20px"
                style={{ marginRight: "4px" }}
              />
              <span className="table-col-heading">
                {languageContent.policy_detail_page.purpose_of_insurance}
              </span>
              <br />
              <span className="table-col-data">
                {user.purpose_of_insurance}
              </span>
            </td>
            <td>
              <Icon
                icon="grommet-icons:plan"
                inline={true}
                color="#505050"
                style={{ marginRight: "0.25rem" }}
              />

              <span className="table-col-heading">
                {languageContent.policy_detail_page.plan_type}
              </span>
              <br />
              <span className="table-col-data">{user.plan_type}</span>
            </td>

          </tr>
        {user?.flow_type && user?.flow_type.toLowerCase() === 'hdfc' ? null :  <tr>
            <td>
              <Icon
                icon="grommet-icons:copy"
                inline={true}
                color="#505050"
                style={{ marginRight: "0.25rem" }}
              />
              <span className="table-col-heading">
                {languageContent.policy_detail_page.application_no}
              </span>
              <br />
              <span className="table-col-data">{user.application_number}</span>
            </td>

          </tr>}
          
        </tbody>
      </table>
      {showButtons && (
        <div className="floatingButton">
          <p>{languageContent.policy_detail_page.info}</p>
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <button
              className="backButton"
              onClick={handleDisagreePolicyDetails}
            >
              {languageContent.buttons.disagree}
            </button>
            <button className="myButton" onClick={handleAgreePolicyDetails}>
              {languageContent.buttons.agree}
            </button>
          </div>
          {/* {(user?.flow_type && user?.flow_type.toLowerCase() === 'hdfc') ? null : (<img
              src="./hand.png"
              className="submitHandIcon"
              alt=""
              style={{ height: "3rem", width: "3rem" }}
            />)} */}
        </div>
      )}
    </> : <LoaderComp />
  );
};

export default PolicyDetails;
